import React, { useState } from 'react'
import LoginForm from './LoginForm'
import { Button, Card, message, notification, Tabs } from 'antd'
import bg from '@/assets/images/bg.png'
import logo from '@/assets/images/login_icon_logo.png'
import { motion } from 'framer-motion'
import PhoneLoginForm from './PhoneLoginForm'
import { tempLoginApi } from '@/api/modules/login'
import { useVisitorId } from '@/hooks/useVisitorId'
import { useNavigate } from 'react-router-dom'
import { HOME_PATH } from '@/config/index.ts'
import styles from './LoginModal.module.css';

const LoginPage: React.FC = () => {
  const navigate = useNavigate()
  const { visitorId, isLoading } = useVisitorId();
  const [loading, setLoading] = useState(false)
  const loginBefore = async () => {
    message.open({
      key: 'login-loading',
      type: 'loading',
      content: '正在处理中，请稍后...',
    })

    await new Promise((resolve: any) => {
      setTimeout(function () {
        message.destroy('login-loading')
        resolve(true)
      }, 2500)
    })
  }
  const loginAfter = () => {
    notification.success({
      message: '欢迎使用Hi.AI',
      description: '',
      duration: 2,
    })
    navigate(HOME_PATH)
  }
  const items = [
    {
      key: '1',
      label: '账号登录',
      children: (
        <LoginForm
          loginBefore={loginBefore}
        />
      ),
    },
    {
      key: '2',
      label: '手机登录',
      children: (
        <PhoneLoginForm
          loginAfter={loginAfter}
        />
      ),
    },
  ];
  const tempLogin = async () => {
    setLoading(true)
    await loginBefore()

    await tempLoginApi({ uniqueId: visitorId })
      .then((res) => {
        localStorage.setItem(import.meta.env.VITE_TOKEN_KEY, res.data)
        loginAfter()

      })
      .finally(() => {
        setLoading(false)
      })
  }
  return (
    <div
      style={{
        display: 'flex',
        height: '100vh',
        overflow: 'hidden', // 防止手机端出现不必要的滚动条
      }}
    >
      {/* 左侧 Banner - 使用 CSS 媒体查询隐藏 */}
      <style>
        {`
          @media (max-width: 1080px) {
            .login-banner {
              display: none !important;
            }
            .login-container {
              flex: 1 !important;
              padding: 20px;
            }
            .login-card {
              width: 100% !important;
              max-width: 400px;
            }
          }
        `}
      </style>

      <div className="login-banner">
        <img
          src={bg}
          alt=""
          style={{
            height: '100%',
            objectFit: 'contain',
          }}
        />
      </div>

      {/* 右侧 登录表单 */}
      <div
        className="login-container"
        style={{
          flex: 2.3,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <img
          src={logo}
          alt="logo"
          style={{ marginBottom: 50, maxWidth: '200px' }}
        />

        <Card
          className="login-card"
          style={{
            width: '400px',
            marginBottom: 100,
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)', // 增加一点阴影让手机端更清晰
          }}
        >
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ type: 'spring', stiffness: 80, delay: 0.2 }}
            style={{ margin: '0 auto', padding: 24 }}
          >
            <Tabs defaultActiveKey="1" items={items} />
            <Button
              type="text"
              block
              loading={loading}
              onClick={tempLogin}
            >
              暂无账号，使用游客账号
            </Button>
            <div className={styles.agreement}>
              注册登录代表已阅读并同意我们的
              <a href="#">用户协议</a> 与 <a href="#">隐私政策</a>，
              未注册的手机号将自动注册
            </div>
          </motion.div>
        </Card>
      </div>
    </div>
  )
}

export default LoginPage
